import { MapPin } from "lucide-react";
import { DONATION, IMAGES } from "../mock/mock";
import useReveal from "../hooks/useReveal";

export default function Donation() {
  const [ref, inView] = useReveal();

  return (
    <section id="don" className="bg-[#f7f4f6] py-16 md:py-24">
      <div
        ref={ref}
        className={`max-w-5xl mx-auto px-5 md:px-8 grid md:grid-cols-2 gap-10 items-center ${inView ? "reveal in-view" : "reveal"}`}
      >
        <div className="flex justify-center">
          <img
            src={IMAGES.esperancePoster}
            alt="Affiche Aidez-nous — Espérance Jeunesse, fonds de soutien à l'enfance"
            width="900"
            height="568"
            loading="lazy"
            decoding="async"
            className="w-full max-w-md rounded-xl object-contain shadow-lg ring-1 ring-[#5c2751]/15"
          />
        </div>
        <div>
          <h2 className="font-heading text-2xl md:text-3xl font-extrabold text-[#5c2751]">
            {DONATION.title}
          </h2>
          <div className="mt-5 space-y-4 text-[15px] leading-relaxed text-[#6c6c6c]">
            {DONATION.paragraphs.map((p) => (
              <p key={p}>{p}</p>
            ))}
          </div>
          <div className="mt-6 flex items-start gap-2 rounded-xl bg-white p-4 text-sm text-[#4a1f42] shadow-sm">
            <MapPin className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#5c2751]" />
            <span>{DONATION.address}</span>
          </div>
        </div>
      </div>
    </section>
  );
}
